import React from "react";
import ReactDOM from "react-dom/client";
import { PrimeReactProvider } from "primereact/api";

import AppProviders from "./providers";

import "./index.css";
import "react-splitter-layout/lib/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PrimeReactProvider value={{ ripple: true, locale: "es" }}>
      <AppProviders />
    </PrimeReactProvider>
  </React.StrictMode>,
);
